(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jenissi-cod"]) return;
  try {
    (()=>{const form=document.getElementById('JenissiCODForm');if(!form||form.dataset.ready==='true')return;form.dataset.ready='true';form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('button[type=submit]');const error=document.getElementById('JenissiCODError');const data=new FormData(form);const attributes={'Nombre':data.get('nombre'),'Teléfono':data.get('telefono'),'Dirección':data.get('direccion'),'Comuna':data.get('comuna'),'Región':data.get('region'),'Email de contacto':data.get('email')||''};button.setAttribute('aria-busy','true');button.disabled=true;error.hidden=true;try{const response=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes})});if(!response.ok)throw new Error('cart-update');window.location.href='/checkout'}catch(e){error.textContent='No pudimos guardar tus datos. Revisa tu conexión e inténtalo nuevamente.';error.hidden=false;button.removeAttribute('aria-busy');button.disabled=false}})})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jenissi-landing-pasta"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.JenissiCarouselAutoplay) return;
  window.JenissiCarouselAutoplay = true;
  const instances = new Map();
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  function init(root) {
    if (instances.has(root)) return;
    const track = root.querySelector(".jv-carousel__track");
    const slides = track ? Array.from(track.querySelectorAll(".jv-slide")) : [];
    const button = root.querySelector(".jv-carousel__toggle");
    if (!track || !button || slides.length < 2) return;

    let pausedByUser = reducedMotion.matches;
    let interacting = false;
    let inView = true;
    let timer = null;
    let resumeTimer = null;
    const cleanups = [];
    const listen = (target, event, handler, options) => {
      target.addEventListener(event, handler, options);
      cleanups.push(() => target.removeEventListener(event, handler, options));
    };
    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };
    const updateButton = () => {
      button.textContent = pausedByUser ? "Reanudar carrusel" : "Pausar carrusel";
      button.setAttribute("aria-label", pausedByUser ? "Reanudar avance automático del carrusel" : "Pausar avance automático del carrusel");
      button.setAttribute("aria-pressed", String(pausedByUser));
    };
    const advance = () => {
      const current = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const next = (current + 1) % slides.length;
      track.scrollTo({
        left: slides[next].offsetLeft,
        behavior: reducedMotion.matches ? "auto" : "smooth"
      });
    };
    const sync = () => {
      stop();
      if (!pausedByUser && !interacting && inView && !document.hidden) {
        timer = window.setInterval(advance, 3000);
      }
    };
    const setInteracting = (value) => {
      interacting = value;
      sync();
    };
    updateButton();
    slides.forEach((slide, index) => {
      slide.setAttribute("role", "group");
      slide.setAttribute("aria-roledescription", "diapositiva");
      slide.setAttribute("aria-label", (index + 1) + " de " + slides.length);
    });

    listen(button, "click", () => {
      pausedByUser = !pausedByUser;
      updateButton();
      sync();
    });
    listen(root, "pointerenter", () => setInteracting(true));
    listen(root, "pointerleave", () => setInteracting(false));
    listen(root, "focusin", () => setInteracting(true));
    listen(root, "focusout", (event) => {
      if (!root.contains(event.relatedTarget)) setInteracting(false);
    });
    listen(root, "touchstart", () => {
      window.clearTimeout(resumeTimer);
      setInteracting(true);
    }, { passive: true });
    listen(root, "touchend", () => {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => setInteracting(false), 2500);
    }, { passive: true });
    listen(document, "visibilitychange", sync);
    listen(reducedMotion, "change", sync);

    let observer = null;
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15 });
      observer.observe(root);
    }

    instances.set(root, () => {
      stop();
      window.clearTimeout(resumeTimer);
      if (observer) observer.disconnect();
      cleanups.forEach((cleanup) => cleanup());
      instances.delete(root);
    });
    sync();
  }

  function scan(container) {
    if (container.matches && container.matches("[data-jv-carousel]")) init(container);
    container.querySelectorAll?.("[data-jv-carousel]").forEach(init);
  }

  const start = () => scan(document);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
  document.addEventListener("shopify:section:load", (event) => scan(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target;
    instances.forEach((dispose, root) => {
      if (section === root || section.contains(root)) dispose();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
